/**
 * Generates a seeded random number generator function.
 *
 * This function uses a linear congruential generator (LCG) algorithm with a
 * modulus of 2147483647 (a prime number) and a multiplier of 16807.
 *
 * @param seed - The initial seed value to start the random number generation.
 * @returns A function that, when called, returns a pseudo-random number between 0 (inclusive) and 1 (exclusive).
 */
export function seededRandom(seed: number) {
  // Ensure seed is positive by adding modulus if negative
  let initialValue = seed % 2147483647;
  if (initialValue <= 0) {
    initialValue += 2147483647;
  }

  let value = initialValue;

  return () => {
    value = (value * 16807) % 2147483647;
    return value / 2147483647;
  };
}
